import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import WritingFocus from './components/WritingFocus';
import ProjectGallery from './components/ProjectGallery';
import EditorialReviews from './components/EditorialReviews';
import CallToAction from './components/CallToAction';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-white to-purple-50">
      <Hero />
      <About />
      <WritingFocus />
      <ProjectGallery />
      <EditorialReviews />
      <CallToAction />
      <Contact />
    </div>
  );
}
